import React, {useState, useEffect} from 'react';
import {Link, withRouter, useLocation} from "react-router-dom";
import {connect} from "react-redux";
import {formatErrors} from "../../constants";
import {toast} from "react-toastify";
import {registerAction} from "../../actions/loginAction";
import {InputLogin} from "../../utils/input/InputLogin";

function Register(props) {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, handleChange] = useState({
    password: '',
    password_repeat: '',
    invite_code: ''
  });

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({...form, [name]: value});
    setErrors({...errors, [name]: value.trim() === ''});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};

    if (form.password.length < 6) {
      errs.password = true;
    }
    if (form.password_repeat.length < 6) {
      errs.password_repeat = true;
    }
    if (form.password !== form.password_repeat) {
      errs.password_repeat = true;
    }

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    setLoading(true);
    props.register(form).then(() => {
      setLoading(false);
      toast.success('Регистрация завершена', {position: toast.POSITION.BOTTOM_RIGHT});
      props.history.push('/');
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  useEffect(() => {
    const invite_code = (new URLSearchParams(location.search)).get('invite_code');
    handleChange(form => {
      return {...form, invite_code}
    });
  }, [location]);

  if(!form.invite_code){
    return null;
  }

  return <div className="auth">
    <form className="auth__wrapper" noValidate onSubmit={handleSubmit}>
      <div className="auth__top">
        <div className="auth__icon" style={{backgroundImage: "url(/img/logo-outline.svg)"}}></div>
        <h3 className="auth__title">Регистрация</h3>
      </div>
      <div className="auth__inner">
        <InputLogin type="password"
                    name="password"
                    placeholder="Введите пароль"
                    title="Пароль"
                    value={form.password}
                    error={errors.password || false}
                    onChange={handleChangeForm}/>

        <InputLogin type="password"
                    name="password_repeat"
                    placeholder="Повторите пароль"
                    title="Пароль"
                    value={form.password_repeat}
                    error={errors.password_repeat || false}
                    onChange={handleChangeForm}/>

        <div className="auth__group"></div>
      </div>
      <div className="auth__buttons">
        <Link to="/login" className="auth__link link">Вход</Link>
        <button className="auth__btn btn" disabled={loading}>Установить пароль</button>
      </div>
    </form>
  </div>;
}

const mapStateToProps = (state) => ({
  lang: state.common.lang
});

const mapDispatchToProps = (dispatch) => {
  return {
    register(data) {
      return dispatch(registerAction(data));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Register))
